import { makeContextModule } from '@cian/react-utils';

import { IApplicationContext } from '../types';

export const { Context: ApplicationContext, useContext: useApplicationContext } =
  makeContextModule<IApplicationContext>({
    contextName: 'ApplicationContext',
  });
